<template>
    <div>
         <ui-data-table headers-on-mobile :tableData="tableData" :tableBodyCustomClass="''" />
    </div>
</template>

<script>
export default {
    name: 'CashAmountTerminals',
    props: {
        terminals: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        tableData() {
            const head = ['ID kasy ', 'Stan gotówki', 'Data aktualizacji']
            const body = this.terminals.map(terminal => {
                return [terminal.id, `${terminal.cash_amount} PLN`, this.$moment(terminal.calculate_date).format('DD-MM-YYYY HH:mm')]
            })

            return { body, head }
        }
    }
}
</script>

<style>

</style>